<template>
  <div class="column-buttons__container" :class="{ 'column-buttons__container--dense': dense }">
    <v-btn
      color="primary"
      rounded="lg"
      :variant="primaryVariant"
      :size="primarySize || undefined"
      :block="primaryBlock"
      :prepend-icon="primaryIcon || undefined"
      :disabled="disablePrimary"
      @click="handlePrimaryClick"
    >
      {{ primaryText }}
    </v-btn>
    <div v-if="$slots.between" class="column-buttons__between">
      <slot name="between" />
    </div>
    <p v-if="disabledReason" class="column-buttons__disabled-reason">
      {{ disabledReason }}
    </p>
    <v-btn
      v-if="showSecondary"
      variant="text"
      rounded="lg"
      :size="secondarySize || undefined"
      :disabled="disableSecondary"
      @click="handleSecondaryClick"
    >
      {{ secondaryText }}
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ColumnButtons',

  props: {
    primaryText: { type: String, required: true },
    primaryIcon: { type: String, default: '' },
    primaryVariant: { type: String, default: 'elevated' },
    primarySize: { type: String, default: '' },
    primaryBlock: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    disablePrimary: { type: Boolean, default: false },
    disabledReason: { type: String, default: '' },
    showSecondary: { type: Boolean, default: true },
    secondaryText: { type: String, default: 'Volver' },
    secondarySize: { type: String, default: '' },
    disableSecondary: { type: Boolean, default: false },
  },

  emits: ['primary-click', 'secondary-click'],

  setup(props, { emit }) {
    const handlePrimaryClick = () => {
      if (!props.disablePrimary) {
        emit('primary-click')
      }
    }

    const handleSecondaryClick = () => {
      if (!props.disableSecondary) {
        emit('secondary-click')
      }
    }

    return {
      handlePrimaryClick,
      handleSecondaryClick,
    }
  },
})
</script>

<style scoped>
.column-buttons__container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
  width: 100%;
  max-width: 343px;
  margin-top: 16px;
  margin-inline: auto;
  box-sizing: border-box;
}

.column-buttons__container--dense {
  gap: 8px;
  margin-top: 0;
}

.column-buttons__container :deep(.v-btn) {
  width: 100%;
  max-width: 100%;
}

.column-buttons__between {
  width: 100%;
  text-align: center;
}

.column-buttons__disabled-reason {
  margin: 0;
  width: 100%;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.4;
  color: #757575;
}
</style>
